import {   
    ADD_CAM_API_SUCCESS,
    ADD_CAM_API_FAIL
} from "./actionTypes";

const INIT_STATE = {
    data: {},
};

const AddCam_Detail = (state = INIT_STATE, action) => {
    switch (action.type) {
        case ADD_CAM_API_SUCCESS:
            return {
                ...state,
                data: action.payload.OK
            };

        case ADD_CAM_API_FAIL:
            return {
                ...state,
                data: action.payload.error
            };

        default:
            return state;
    }
}

export default AddCam_Detail;